import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path d=\"M21.7166 14.3736C21.9018 13.6127 22 12.8178 22 11.9999C22 6.81459 18.0533 2.55104 13 2.04932V11.2928L21.7166 14.3736Z\" fill=\"currentColor\"></path><path d=\"M21.0501 16.2593L11.6668 12.9428C11.2672 12.8015 11 12.4238 11 11.9999V2.04932C5.94668 2.55104 2 6.81459 2 11.9999C2 17.5228 6.47715 21.9999 12 21.9999C15.9995 21.9999 19.4506 19.652 21.0501 16.2593Z\" fill=\"currentColor\"></path><defs><linearGradient id=\"paint0_linear_3364_4767\" x1=\"12\" y1=\"2.04932\" x2=\"12\" y2=\"21.9999\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"currentColor\"></stop><stop offset=\"1\" stop-color=\"currentColor\"></stop></linearGradient><linearGradient id=\"paint1_linear_3364_4767\" x1=\"12\" y1=\"2.04932\" x2=\"12\" y2=\"21.9999\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"currentColor\"></stop><stop offset=\"1\" stop-color=\"currentColor\"></stop></linearGradient></defs>", 3)
const _hoisted_5 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }